import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CategoryMaintenanceRoutingModule } from './category-maintenance-routing.module';
import { CategoryMaintenanceComponent } from './category-maintenance.component';
import { CategoryMaintenanceFormComponent } from './category-maintenance-form/category-maintenance-form.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';
import { MaintenanceListModule } from 'src/app/core/custom-modules/maintenance-list/maintenance-list.module';
import { MaintenanceDetailModule } from 'src/app/core/custom-modules/maintenance-detail/maintenance-detail.module';
import { CategoryMaintenanceFilterComponent } from './category-maintenance-filter/category-maintenance-filter.component';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
    MaintenanceListModule,
    MaintenanceDetailModule,
    CategoryMaintenanceRoutingModule
  ],
  declarations: [CategoryMaintenanceComponent, CategoryMaintenanceFormComponent, CategoryMaintenanceFilterComponent],
  entryComponents: [CategoryMaintenanceFilterComponent]
})
export class CategoryMaintenanceModule { }